import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'menu',
    loadChildren: () => import('./drawer/drawer.routes').then((m) => m.routes),
  },
  {
    path: 'hotel-booking',
    loadComponent: () =>
      import('./templates/hotel-booking/hotel-booking.page').then(
        (m) => m.HotelBookingPage
      ),
  },
  {
    path: 'course-rive',
    loadComponent: () =>
      import('./templates/course-rive/course-rive.page').then(
        (m) => m.CourseRivePage
      ),
  },
  {
    path: 'super-app',
    loadComponent: () =>
      import('./pages/super-app/super-app.component').then(
        (m) => m.SuperAppComponent
      ),
  },
  {
    path: 'sign-up',
    loadComponent: () =>
      import('./pages/register/register.component').then(
        (m) => m.RegisterComponent
      ),
  },
  {
    path: 'sign-in',
    loadComponent: () =>
      import('./pages/login/login.component').then(
        (m) => m.LoginComponent
      ),
  },
  {
    path: '',
    redirectTo: 'menu',
    pathMatch: 'full',
  },
];
